import * as React from 'react';

import { useLocation } from 'react-router-dom';

import type * as StockAnalytics from '@/telemetry/stockAnalytics';

// Loaded on demand: stock analytics pulls the stock API into the initial bundle otherwise.
let stockAnalytics: Promise<typeof StockAnalytics> | null = null;

function trackStockPageViewed(pathname: string): void {
  stockAnalytics ??= import('@/telemetry/stockAnalytics');
  void stockAnalytics.then(
    (module) => {
      module.trackStockPageViewed(pathname);
    },
    () => {
      stockAnalytics = null;
    },
  );
}

function shouldTrackPathname(
  lastTrackedPathnameRef: React.MutableRefObject<string | null>,
  pathname: string,
): boolean {
  if (lastTrackedPathnameRef.current === pathname) {
    return false;
  }
  lastTrackedPathnameRef.current = pathname;
  return true;
}

export function ProductAnalyticsRouteObserver() {
  const location = useLocation();
  const lastPathnameRef = React.useRef<string | null>(null);

  React.useEffect(() => {
    if (!shouldTrackPathname(lastPathnameRef, location.pathname)) {
      return;
    }
    trackStockPageViewed(location.pathname);
  }, [location.pathname]);

  return null;
}
